import {
	InvoiceStanding,
	InvoiceStatus,
	InvoiceTaxStatus,
	PaymentStatus,
	QuickBooksExportStatus
} from "~/gql/graphqlBase.generated";

// gridId registered in wsapi's GridRegistry.BuildInvoicesConfig, one row per invoice, shared by Receive Payments and the Invoices list.
export const INVOICES_GRID_ID = "invoices";

// Mirrors GridRegistry.BuildInvoicesConfig's OutputColumns; customerName, accruedLateCharge, availableDiscount and lateChargeWaived are output-only, so filter and sort on customerId instead.
export type InvoicesSsrmRow = {
	accruedLateCharge: number;
	amountPaid: number;
	availableDiscount: number;
	balance: number;
	customerId: string;
	customerName: string | null;
	depositApplied: number;
	dueDate: string;
	freight: number;
	id: string;
	invoiceDate: string;
	invoiceId: string;
	invoiceNumber: string;
	lateChargeWaived: number;
	orderId: string;
	orderNumber: string;
	paymentStatus: PaymentStatus;
	quickBooksExportStatus: QuickBooksExportStatus;
	standing: InvoiceStanding;
	status: InvoiceStatus;
	subtotal: number;
	taxStatus: InvoiceTaxStatus;
	taxTotal: number;
	total: number;
};
